import { render, staticRenderFns } from "./generalConfig.vue?vue&type=template&id=35493cb7&"
import script from "./generalConfig.vue?vue&type=script&lang=js&"
export * from "./generalConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports